const{ConnectionRequestStatus} = require('wuc-library/enums');
exports.validTransitions = {
        [ConnectionRequestStatus.SUBMITTED]: [ConnectionRequestStatus.SUBMITTED,ConnectionRequestStatus.REVIEW,ConnectionRequestStatus.APPROVED, ConnectionRequestStatus.DECLINED,ConnectionRequestStatus.COMPLETE],
        [ConnectionRequestStatus.REVIEW]: [ConnectionRequestStatus.REVIEW,ConnectionRequestStatus.APPROVED, ConnectionRequestStatus.DECLINED,ConnectionRequestStatus.COMPLETE],
        //[ConnectionRequestStatus.RETURNED]: [ConnectionRequestStatus.SUBMITTED, ConnectionRequestStatus.DECLINED],
        [ConnectionRequestStatus.APPROVED]: [ConnectionRequestStatus.APPROVED,ConnectionRequestStatus.COMPLETE],
        [ConnectionRequestStatus.DECLINED]: [ConnectionRequestStatus.DECLINED],
        [ConnectionRequestStatus.COMPLETE]: [ConnectionRequestStatus.COMPLETE]
    };
